import React from 'react'

const ROWS = [1, 2, 3, 4, 5, 6, 7]

/**
 * Placeholder rows matching the real grid template, so the table does not jump
 * when the counts land.
 */
const TableSkeleton = ({ columns, gridTemplate }) => (
  <div data-testid="table-skeleton">
    {ROWS.map((row) => (
      <div className="od-row od-row-skel" key={`skel-${row}`} style={gridTemplate}>
        <div className="od-skel" style={{ height: 13, width: '80%' }} />
        <div className="od-skel" style={{ height: 10, width: '100%' }} />
        {Array.from({ length: columns }).map((_, index) => (
          <div
            className="od-skel od-skel-num"
            key={`skel-${row}-${index}`}
            style={{ height: 13, width: 22 }}
          />
        ))}
        <div
          className="od-skel od-skel-num"
          style={{ height: 13, width: 26 }}
        />
      </div>
    ))}
  </div>
)

export default TableSkeleton
